// src/page/RouteErrorPage.jsx
import React from "react";
import { Result, Button, Space } from "antd";
import { useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import i18n from "i18next";
import { basename } from "@/setting";

const buildHomeUrl = (bn, lang) => {
  const base = String(bn || "").replace(/^\/+|\/+$/g, "");
  const l = String(lang || "").replace(/^\/+|\/+$/g, "");
  return `/${[base, l].filter(Boolean).join("/")}`;
};

export default function RouteErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  const homeUrl = buildHomeUrl(basename, i18n.language);

  let title = "System Error";
  let subTitle = "你可以刷新页面或返回首页。";

  if (isRouteErrorResponse(error)) {
    // loader/action throw Response 的情况
    title = `${error.status} ${error.statusText}`;
    subTitle = error.data?.message || error.data || subTitle;
  } else if (error instanceof Error) {
    // 渲染错误
    subTitle = error.message || subTitle;
  } else if (error) {
    subTitle = String(error);
  }

  return (
    <div style={{ padding: 24 }}>
      <Result
        status="error"
        title={title}
        subTitle={subTitle}
        extra={
          <Space>
            <Button type="primary" onClick={() => window.location.reload()}>
              Refresh
            </Button>
            <Button onClick={() => navigate(homeUrl)}>Back to Home</Button>
          </Space>
        }
      />
    </div>
  );
}
